if (!customElements.get('card-variant-image')) {
  class CardVariantImage extends HTMLElement {
    connectedCallback() {
      this.cardWrapper = this.closest('.card-wrapper');
      this.image = this.querySelector('[data-card-variant-image]');
      this.variantImages = new Map(
        JSON.parse(this.dataset.variantImages || '[]').map((variantImage) => [
          String(variantImage.id),
          variantImage,
        ])
      );

      if (!this.cardWrapper || !this.image) return;

      if (!this.originalImageAttributes) {
        this.originalImageAttributes = ['src', 'srcset', 'alt', 'width', 'height'].reduce(
          (attributes, name) => {
            attributes[name] = this.image.getAttribute(name);
            return attributes;
          },
          {}
        );
      }
      this.onCardChange = this.onCardChange.bind(this);
      this.cardWrapper.addEventListener('change', this.onCardChange);
      this.updateImage(this.getSelectedVariantId());
    }

    disconnectedCallback() {
      if (this.cardWrapper && this.onCardChange) {
        this.cardWrapper.removeEventListener('change', this.onCardChange);
      }
    }

    onCardChange(event) {
      const eventTarget = event.target;
      if (!(eventTarget instanceof Element)) return;

      const variantPicker = eventTarget.closest('variant-selects[data-context="card"]');
      if (!variantPicker || !this.cardWrapper.contains(variantPicker)) return;

      this.updateImage(this.getSelectedVariantId(variantPicker));
    }

    getSelectedVariantId(variantPicker) {
      const picker =
        variantPicker || this.cardWrapper.querySelector('variant-selects[data-context="card"]');
      const variantInput = picker?.closest('product-form')?.querySelector('.variant-id-input');

      if (picker?.dataset.unified === 'true') {
        const select = picker.querySelector('select');
        const selectedVariantId = select?.value;

        if (selectedVariantId && variantInput?.value !== selectedVariantId) {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        return selectedVariantId || variantInput?.value;
      }

      return variantInput?.value;
    }

    updateImage(variantId) {
      const variantImage = this.variantImages.get(String(variantId));
      const attributes = variantImage || this.originalImageAttributes;

      Object.entries(attributes).forEach(([name, value]) => {
        if (value == null) {
          this.image.removeAttribute(name);
        } else {
          this.image.setAttribute(name, value);
        }
      });
    }
  }

  customElements.define('card-variant-image', CardVariantImage);
}
